<script setup>
import dayjs from "dayjs";
import {computed} from "vue";
import {useThread} from "@/Store/Thread.js";
import {storeToRefs} from "pinia";
import {Link, usePage} from "@inertiajs/vue3";
import {route} from "ziggy-js";

const props = defineProps({
    message: Object,
})

const storeThread = useThread(),
    {thread} = storeToRefs(storeThread)


const whoseMessage = computed(() => {
    return props.message.user_id === usePage().props.auth.user.id
})


const getUser = computed(() => {
    return thread.value.participants.find(participant => participant.user?.id === props.message.user_id)?.user
})

const isMessageAdmin = computed(() => {
    return props.message.from_admin;
})

</script>

<template>
    <div
        :class="[{'bg-slate-100 dark:bg-blue-900': whoseMessage}, {'dark:bg-gray-700': !whoseMessage}, {'border-blue-600 border' : isMessageAdmin}]"
        class="px-2 py-1 rounded-lg">
        <div class="flex justify-between leading-120">
            <span v-if="isMessageAdmin" class="text-blue-600 tracking-wider">{{ $t('ANYKOD Administration') }}</span>
            <span v-else class="tracking-wider dark:text-slate-200">{{ getUser?.name }}</span>
            <span
                class="text-xs text-slate-500 font-normal dark:text-slate-400">{{
                    dayjs(message.created_at).format('HH:mm')
                }}</span>
        </div>
        <div :class="{'text-right': whoseMessage}" class="font-normal text-sm break-words">
            <div v-if="message.file_url" class="cursor-pointer w-fit relative">
                <embed :src="message.file_url" class="w-25 rounded-lg py-1" type="">
                <div class="absolute inset-0" @click="$emit('showImg', message.file_url)"></div>
            </div>
            <img v-else-if="message.file_url && message.file_url.includes('uploads')" :src="message.file_url"
                 :alt="$t('Picture')" class="aspect-square w-25 h-25 rounded-lg cursor-pointer"
                 @click="$emit('showImg', message.file_url)"/>
            <span class="dark:text-slate-200 whitespace-pre-wrap" v-if="isMessageAdmin"  v-html="message.body"></span>
            <span class="dark:text-slate-200 whitespace-pre-wrap" v-else>{{message.body}}</span>
            <div v-if="message.offer && route().current('threads.*') && message.user_id !== $page.props.auth.user.id"
                 class="border border-slate-300 dark:border-slate-700 bg-slate-200 dark:bg-slate-800 p-1 flex gap-1 rounded-md">
                <ion-icon name="chatbubble-ellipses" class="text-xl align-middle text-slate-500"></ion-icon>
                <div class="text-sm text-slate-500 font-normal tracking-wider">
                    <span class="leading-120">{{ $t('texted from') }}: </span>
                    <span class="text-blue-600 leading-120">
                        <Link :href="route('offers.show', message.offer.id)">
                            {{ message.offer.title }}
                        </Link>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
